/**
 * Registers all built-in SVS renderers.
 * Import this module once at app startup to populate the registry.
 */
import { registerRenderer } from './registry'

import { PieRenderer } from './renderers/PieRenderer'
import { BarRenderer } from './renderers/BarRenderer'
import { LineRenderer } from './renderers/LineRenderer'
import { AreaRenderer } from './renderers/AreaRenderer'
import { ScatterRenderer } from './renderers/ScatterRenderer'
import { FunnelRenderer } from './renderers/FunnelRenderer'
import { SankeyRenderer } from './renderers/SankeyRenderer'
import { TreemapRenderer } from './renderers/TreemapRenderer'
import { HeatmapRenderer } from './renderers/HeatmapRenderer'
import { GaugeRenderer } from './renderers/GaugeRenderer'
import { KpiRenderer } from './renderers/KpiRenderer'
import { MetricRowRenderer } from './renderers/MetricRowRenderer'
import { TableRenderer } from './renderers/TableRenderer'
// DashboardRenderer is handled specially in SVSRenderer (recursive rendering)

registerRenderer('pie', PieRenderer)
registerRenderer('donut', PieRenderer)      // Donut reuses PieRenderer
registerRenderer('bar', BarRenderer)
registerRenderer('line', LineRenderer)
registerRenderer('area', AreaRenderer)
registerRenderer('scatter', ScatterRenderer)
registerRenderer('funnel', FunnelRenderer)
registerRenderer('sankey', SankeyRenderer)
registerRenderer('treemap', TreemapRenderer)
registerRenderer('heatmap', HeatmapRenderer)
registerRenderer('gauge', GaugeRenderer)
registerRenderer('kpi', KpiRenderer)
registerRenderer('metric-row', MetricRowRenderer)
registerRenderer('table', TableRenderer)
